import React, { FC } from 'react';

import { ArtistExclusive } from '../ArtistExclusive/ArtistExclusive';

interface FromTheArtistProps {
  analytics: Analytics;
  artistName?: string;
  components: ProductType['fromTheArtistContainer'];
  title: string;
}

export const FromTheArtist: FC<FromTheArtistProps> = ({
  analytics,
  artistName = '',
  components,
  title,
}) => (
  <ArtistExclusive
    analytics={analytics}
    artistName={artistName}
    exclusive={components}
    title={title}
  />
);
